import * as React from 'react';
import { Menu, MenuItem, ListItemIcon, PopoverOrigin } from '@material-ui/core';
import MobileFriendlyIcon from '@material-ui/icons/MobileFriendly';
import PhonelinkEraseIcon from '@material-ui/icons/PhonelinkErase';
import DeviceUnknownIcon from '@material-ui/icons/DeviceUnknown';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';
import { AppointmentConfirmationEditableStatus } from '../../shared/appointmint/appointmentConfirmationStatus';

interface AppointmentConfirmationStatusMenuProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    onSelect: (status: AppointmentConfirmationEditableStatus) => void;
    anchorOrigin?: PopoverOrigin;
    transformOrigin?: PopoverOrigin;
}

const listItemIconStyle = { minWidth: '2rem' };

const AppointmentConfirmationStatusMenu: React.FC<AppointmentConfirmationStatusMenuProps> = ({
    anchorEl,
    open,
    onClose,
    onSelect,
    anchorOrigin,
    transformOrigin,
}) => {
    const t = useTranslations();

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
        >
            <MenuItem onClick={() => onSelect('confirmed')}>
                <ListItemIcon style={listItemIconStyle}>
                    <MobileFriendlyIcon fontSize="small" style={{ color: 'var(--success-color)' }} />
                </ListItemIcon>
                {t(TK.confirmed)}
            </MenuItem>
            <MenuItem onClick={() => onSelect('rejected')}>
                <ListItemIcon style={listItemIconStyle}>
                    <PhonelinkEraseIcon fontSize="small" style={{ color: 'var(--danger-color)' }} />
                </ListItemIcon>
                {t(TK.clientRejectedAppointment)}
            </MenuItem>
            <MenuItem onClick={() => onSelect('pending')}>
                <ListItemIcon style={listItemIconStyle}>
                    <DeviceUnknownIcon fontSize="small" style={{ color: 'var(--warning-color)' }} />
                </ListItemIcon>
                {t(TK.clientAwaitingConfirmation)}
            </MenuItem>
        </Menu>
    );
};

export default AppointmentConfirmationStatusMenu;
